






















import { computed, defineComponent, onUnmounted, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS } from "@/const";
import BaseSpinner from "@/components/BaseSpinner";
import MainNavigationBar from "@/components/MainNavigationBar";

export default defineComponent({
  name: "MainNavigationView",
  components: { BaseSpinner, MainNavigationBar },
  props: {
    isChangedFeatures: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  setup(props) {
    const hideMenuManual = ref(false);
    const { allowAccess } = useAuthUser();

    const showPoweredBy = computed(() => !config.featureHideScrileLink);
    const showMenu = computed(() => allowAccess.value && !props.loading);

    const hideMenuHandler = (hide = false) => (hideMenuManual.value = hide);
    emitter.on<any>(EVENTS.MAIN_MENU_HIDE, hideMenuHandler);
    onUnmounted(() => emitter.off<any>(EVENTS.MAIN_MENU_HIDE, hideMenuHandler));

    return {
      showMenu,
      hideMenuManual,
      showPoweredBy,
    };
  },
});
